import React from 'react';

function ResourcesRow({ resource }) {
  return (
    <div className="resources__row row">
      <div className="resources__main">
        <h2 className="resources__subheading">
          {resource.title}
        </h2>
        <div className="resources__subtext">
          {resource.subtext}
        </div>
        <div className="resources__description">
          <p>
            {resource.description}
          </p>
          {resource.url && (
            <p>
              <a
                href={resource.url}
                // className="button button--large button--full-width resources__button"
                target="_blank"
                rel="noreferrer noopener"
              >
                {resource.url}
              </a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResourcesRow;



// WEBPACK FOOTER //
// ./src/components/features/resources/ResourcesRow.js